/**
 * NotificationPreferencesContext
 * 
 * 管理推送通知偏好的 Context
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getItem, setItem } from '../utils/localStorage';

const NotificationPreferencesContext = createContext(null);

const STORAGE_KEY = 'notificationPreferences';
const DEFAULT_PREFERENCES = {
  mtr: [], // MTR 路線列表，例如 ['TWL', 'KTL'] 或 ['ALL']
  immi: false, // 是否接收口岸人流通知
};

export const NotificationPreferencesProvider = ({ children }) => {
  const [preferences, setPreferences] = useState(() => {
    const stored = getItem(STORAGE_KEY);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (e) {
        console.error('Failed to parse notification preferences:', e);
        return DEFAULT_PREFERENCES;
      }
    }
    return DEFAULT_PREFERENCES;
  });

  // 當偏好改變時，保存到 localStorage
  useEffect(() => {
    setItem(STORAGE_KEY, JSON.stringify(preferences));
  }, [preferences]);

  // 更新 MTR 路線偏好
  const updateMTRPreferences = (lines) => {
    setPreferences((prev) => ({
      ...prev,
      mtr: lines,
    }));
  };

  // 更新口岸人流通知偏好
  const updateImmigrationPreference = (enabled) => {
    setPreferences((prev) => ({
      ...prev,
      immi: enabled,
    }));
  };

  // 重置偏好
  const resetPreferences = () => {
    setPreferences(DEFAULT_PREFERENCES);
  };

  const value = {
    preferences,
    updateMTRPreferences,
    updateImmigrationPreference,
    resetPreferences,
  };

  return (
    <NotificationPreferencesContext.Provider value={value}>
      {children}
    </NotificationPreferencesContext.Provider>
  );
};

export const useNotificationPreferences = () => {
  const context = useContext(NotificationPreferencesContext);
  if (!context) {
    throw new Error(
      'useNotificationPreferences must be used within NotificationPreferencesProvider'
    );
  }
  return context;
};

